<template>
  <form>
    <div class="input-group">
      <input type="text" class="form-control" :placeholder="placeholder">
      <div class="input-group-append">
        <div class="input-group-text">
          <i class="fa fa-fw fa-search"></i>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: undefined
    }
  }
};
</script>
